/**
 * GET DURATION
 * @param {number} start date as timestamp in second (like python TS)
 * @param {number} end date as timestamp in second (like python TS)
 * @return {string} duration in hours/minutes '3H24'or only minutes '51 min'
 */

export default {
  methods: {
    getDuration(start, end) {
      const duration = end - start;
      const hours = new Date(duration * 1000).getHours() - 1;
      const minutes = new Date(duration * 1000).getMinutes();
      if (hours > 0) {
        return `${hours < 10 ? `0${hours}` : hours}H${minutes < 10 ? `0${minutes}` : minutes}`;
      }
      return `${minutes} min`;
    },
  },
};
